import axios from 'axios';
import store from '@/store';
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { Mutations, Endpoints } from '@/ts/store/Constants';
import ErrorResponse from '@/ts/ErrorResponse';

@Module({name: 'StaffProperties', namespaced: true})
export default class StaffProperties extends VuexModule {
    public staffProperties: any[] = [];
    public staffCurrentProperty: any = null;
    public staffPropertyIconLink: number = 0;
    public staffChatBackLink: boolean = false;
    public indexPagesKeyboardVisibility: boolean = false;

    @Mutation
    public RESET_STAFF_PROPERTIES_STORE_STATE() {
        this.staffProperties              = [];
        this.staffCurrentProperty         = null;
        this.staffPropertyIconLink        = 0;
        this.staffChatBackLink            = false;
        this.indexPagesKeyboardVisibility = false;
    }

    get getStaffProperties() {
        return this.staffProperties;
    }

    get getStaffChatBackLink() {
        return this.staffChatBackLink;
    }

    get getStaffCurrentProperty() {
        return this.staffCurrentProperty;
    }

    get getStaffPropertyIconLink() {
        return this.staffPropertyIconLink;
    }

    get getIndexPagesKeyboardVisibility() {
        return this.indexPagesKeyboardVisibility;
    }

    @Action
    public FETCH_ALL_STAFF_PROPERTIES() {
        axios.get(Endpoints.Properties.STAFF_PROPERTIES)
            .then((response: any) => {
                store.commit(Mutations.SET_STAFF_PROPERTIES, response.data.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public FETCH_STAFF_PROPERTY(propertyId: number) {
        axios.get(Endpoints.Properties.STAFF_PROPERTY(propertyId))
            .then((response: any) => {
                store.commit(Mutations.SET_STAFF_CURRENT_PROPERTY, response.data.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Mutation
    public SET_STAFF_PROPERTIES(data: any) {
        this.staffProperties = data;
    }

    @Mutation
    public SET_STAFF_CURRENT_PROPERTY(data: any) {
        this.staffCurrentProperty = data;
    }

    @Mutation
    public SET_STAFF_PROPERTY_ICON_LINK(id: number) {
        this.staffPropertyIconLink = id;
    }

    @Mutation
    public SET_STAFF_CHAT_BACK_LINK(toConversations: boolean) {
        this.staffChatBackLink = toConversations;
    }

    @Mutation
    public SET_INDEX_PAGES_KEYBOARD_VISIBILITY(visibility: boolean) {
        this.indexPagesKeyboardVisibility = visibility;
    }
}
